export default __webpack_public_path__ + "static/media/IMG_20230625_022008 - 018_EE-A2_Navneet Raj.534df321.jpg";